import type { AiModelEnum, Annotation, EvidenceSessionAIModel } from 'api';
import { Box } from 'ui';

import { SegmentationOverlay } from '../SegmentationOverlay/SegmentationOverlay';

interface AnnotatedMediaItemProps {
  image: string;
  annotations: Annotation[];
  showLegend?: boolean;
  hiddenCategories?: string[];
  model: AiModelEnum | EvidenceSessionAIModel;
}

export const AnnotatedMediaItem = ({
  image,
  annotations,
  showLegend = true,
  hiddenCategories = [],
  model,
}: AnnotatedMediaItemProps) => {
  return (
    <Box padding={2} paddingTop={0}>
      <SegmentationOverlay
        imageSrc={image}
        annotations={annotations}
        hiddenCategories={hiddenCategories}
        model={model}
        showLegend={showLegend}
      />
    </Box>
  );
};
